
import React, { useState } from 'react';
import { 
  Tabs, 
  TabsContent, 
  TabsList, 
  TabsTrigger 
} from "@/components/ui/tabs";
import { 
  Card,
  CardContent
} from "@/components/ui/card";
import CampaignDashboard from './CampaignDashboard';
import CampaignPlanner from './CampaignPlanner';
import CampaignTemplates from './CampaignTemplates';
import CampaignAnalytics from './CampaignAnalytics';
import { Calendar, Target, Presentation, LayoutTemplate } from 'lucide-react';

const MarketingCampaigns: React.FC = () => {
  const [activeTab, setActiveTab] = useState("dashboard");

  return (
    <div className="space-y-6">
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 to-violet-500/20 blur-2xl -z-10 rounded-3xl"></div>
        <Card className="border-0 shadow-xl bg-background/70 backdrop-blur-sm overflow-hidden">
          <CardContent className="p-0">
            <Tabs 
              defaultValue="dashboard" 
              value={activeTab}
              onValueChange={setActiveTab}
              className="w-full"
            >
              <TabsList className="w-full grid grid-cols-4 bg-muted/50 p-1 rounded-none border-b">
                <TabsTrigger value="dashboard" className="data-[state=active]:bg-background rounded-none">
                  <div className="flex items-center gap-2">
                    <Presentation className="h-4 w-4" />
                    <span className="hidden sm:inline">Dashboard</span>
                  </div>
                </TabsTrigger>
                <TabsTrigger value="planner" className="data-[state=active]:bg-background rounded-none">
                  <div className="flex items-center gap-2">
                    <Calendar className="h-4 w-4" />
                    <span className="hidden sm:inline">Planner</span>
                  </div>
                </TabsTrigger>
                <TabsTrigger value="templates" className="data-[state=active]:bg-background rounded-none">
                  <div className="flex items-center gap-2">
                    <LayoutTemplate className="h-4 w-4" />
                    <span className="hidden sm:inline">Templates</span>
                  </div>
                </TabsTrigger>
                <TabsTrigger value="analytics" className="data-[state=active]:bg-background rounded-none">
                  <div className="flex items-center gap-2">
                    <Target className="h-4 w-4" />
                    <span className="hidden sm:inline">Analytics</span>
                  </div>
                </TabsTrigger>
              </TabsList>
              
              <TabsContent value="dashboard" className="mt-0">
                <CampaignDashboard />
              </TabsContent>
              
              <TabsContent value="planner" className="mt-0">
                <CampaignPlanner />
              </TabsContent>
              
              <TabsContent value="templates" className="mt-0">
                <CampaignTemplates />
              </TabsContent>
              
              <TabsContent value="analytics" className="mt-0">
                <CampaignAnalytics />
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default MarketingCampaigns;
